import React from 'react';
import _ from 'lodash';
import LinearProgressBar from '../linear-progress-bar/LinearProgressbar';
import { isEmpty } from '../../utils/object-utils';
import './analytics-table.scss';

export default function AnalyticsTable({ tableProperties, tableData }) {
    function getTableHeader() {
        if (isEmpty(tableProperties) || isEmpty(tableData)) {
            return null;
        }

        const tableHeaders = tableProperties.map((tableProperty) => {
            return <th key={_.uniqueId('thead_')}
                className='table-cell-root table-cell-head'
                role='columnheader' scope='row'>{tableProperty.headerText}</th>;
        });

        return <thead className='table-head-root'>
            <tr className='table-row-root'>
                {tableHeaders}
            </tr>
        </thead>;
    }

    function getTableRows() {
        if (isEmpty(tableProperties) || isEmpty(tableData)) {
            return null;
        }

        return tableData.map((tableRow) =>
            <tr key={_.uniqueId('trow_')} className='table-row-root'>
                {getTableRowData(tableRow)}
            </tr>);
    }

    function getTableRowData(rowData) {
        return tableProperties.map((tableProperty) => {
            return (
                <td key={_.uniqueId('tdata_')} className='table-cell-root table-cell-body'>
                    {getTableRowElement(rowData, tableProperty)}
                </td>);
        });
    }

    function getTableRowElement(rowData, tableProperty) {
        if (tableProperty.isProgressBar) {
            return <LinearProgressBar completedPercentage={rowData[tableProperty.property]}></LinearProgressBar>;
        }
        const tableElement = rowData[tableProperty.property];
        if (!_.isArray(tableElement)) {
            return rowData[tableProperty.property];
        }

        const foundElement = tableElement.find(x => x[tableProperty.arrayKey] === tableProperty.arrayValue);

        if (_.isEmpty(foundElement)) {
            return null;
        }

        return foundElement[tableProperty.arrayProperty];
    }

    return (
        <div className='table-container'>
            <table className='table-root'>
                {getTableHeader()}
                <tbody className='table-body'>
                    {getTableRows()}
                </tbody>
            </table>
        </div >
    );
}
